export enum CommandName {
  CHAT_THERAPIST_UNABLE_TO_LEAVE = 'CHAT_THERAPIST_UNABLE_TO_LEAVE',
  CHAT_MORE_MESSAGES = 'CHAT_MORE_MESSAGES',
  SET_ACTIVE_CHANNEL = 'SET_ACTIVE_CHANNEL',
  CHAT_SUMMARY_NOT_FOUND = 'CHAT_SUMMARY_NOT_FOUND'
}
